export function unique<T>(values: readonly T[]): T[] {
  return Array.from(new Set(values));
}

export function uniqueSorted(values: readonly string[]): string[] {
  return unique(values).sort();
}

export function haveSameUniqueValues<T>(first: readonly T[], second: readonly T[]): boolean {
  const firstSet = new Set(first);
  const secondSet = new Set(second);

  if (firstSet.size !== secondSet.size) {
    return false;
  }

  for (const value of firstSet) {
    if (!secondSet.has(value)) {
      return false;
    }
  }

  return true;
}
